import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {PageableModel} from "../../common/models/table";
import {TransportRegisterModel, TransportRegisterFilters} from "../models/transportRegister";
import {AxiosResponse} from "axios";
import {DownloadService} from "../../common/services/downloadService";

export class TransportRegisterService {
    private static baseUrl = apiUrls.reports.transportRegister;

    public static async generateReport(filters: TransportRegisterFilters): Promise<AxiosResponse<PageableModel<TransportRegisterModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<TransportRegisterModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: TransportRegisterFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: TransportRegisterFilters) {
        return `arrivalFerryFrom=${filters.arrivalFerryFrom}&arrivalFerryTo=${filters.arrivalFerryTo}` +
            `&departureFerryFrom=${filters.departureFerryFrom}&departureFerryTo=${filters.departureFerryTo}` +
            `&ferryEntityId=${filters.ferryEntityId}&shipownerEntityId=${filters.shipownerEntityId}` +
            `&wharfId=${filters.wharfId}&originDestinationPortId=${filters.originDestinationPortId}&actionType=${filters.actionType}`;
    }
}
